'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOAST_DISMISS = exports.TOAST_DISMISS = 'TOAST_DISMISS';
var TOAST_MESSAGE = exports.TOAST_MESSAGE = 'TOAST_MESSAGE';
var TOAST_UPDATE = exports.TOAST_UPDATE = 'TOAST_UPDATE';